package games.polyclub.website.frontend.store.pages

import games.polyclub.frontend.lib.react.bootstrap.components.Card
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.h2
import games.polyclub.frontend.lib.react.simplified.tags.p
import games.polyclub.message.unaryMinus
import games.polyclub.website.frontend.store.context.addBreadcrumb
import games.polyclub.website.frontend.store.layout.PageBody
import games.polyclub.website.frontend.store.layout.PageHeader
import games.polyclub.website.frontend.store.sitemap.PublicSitemap
import react.Props

val PrivacyTermsPage = SFC<Props> { _ ->
    addBreadcrumb(PublicSitemap.PRIVACY_TERMS.pathPart, -"Política de Privacidade")

    PageHeader {
        title = -"Política de Privacidade da PolyClub"
    }
    PageBody {
        Card {
            h2 {
                +"1. Introdução"
            }
            p {
                +"Bem-vindo à Política de Privacidade da PolyClub. Nossa prioridade é proteger seus dados pessoais e garantir sua privacidade. Esta política explica como coletamos, usamos e protegemos suas informações pessoais em conformidade com a Lei Geral de Proteção de Dados (LGPD)."
            }

            h2 {
                +"2. Coleta e Armazenamento de Dados Pessoais"
            }
            p {
                +"Nós coletamos e armazenamos dados pessoais de forma segura e, quando necessário, por um tempo limitado, sempre com o seu consentimento expresso. Valorizamos a segurança e a privacidade de seus dados."
            }

            h2 {
                +"3. Uso de Cookies"
            }
            p {
                +"Utilizamos cookies para garantir o funcionamento adequado de nosso site. É importante ressaltar que não rastreamos usuários quando estão deslogados, protegendo sua privacidade."
            }

            h2 {
                +"4. Análises Estatísticas"
            }
            p {
                +"Realizamos análises estatísticas de forma anônima para melhorar nossos serviços. Essas análises são semelhantes às usadas por serviços como o Google Analytics. Não associamos esses dados a identidades pessoais e garantimos sua privacidade durante esse processo."
            }

            h2 {
                +"5. Compartilhamento de Dados"
            }
            p {
                +"Não compartilhamos seus dados pessoais com terceiros sem o seu consentimento expresso. Sua privacidade é importante para nós, e estamos comprometidos em proteger suas informações."
            }

            h2 {
                +"6. Seus Direitos"
            }
            p {
                +"Você tem o direito de acessar, retificar ou excluir seus dados pessoais a qualquer momento. Se desejar exercer esses direitos ou tiver alguma dúvida sobre nossa política de privacidade, entre em contato conosco por meio dos canais de suporte fornecidos em nosso site."
            }

            h2 {
                +"7. Alterações na Política de Privacidade"
            }
            p {
                +"Reservamo-nos o direito de alterar esta política de privacidade a qualquer momento. As alterações serão comunicadas por meio do nosso site. Recomendamos que você verifique regularmente a política de privacidade para estar informado sobre quaisquer atualizações."
            }

            h2 {
                +"8. Contato"
            }
            p {
                +"Para entrar em contato em relação a dúvidas, problemas ou informações gerais sobre nossa política de privacidade, você pode fazê-lo por meio dos canais de suporte fornecidos em nosso site."
            }

            p {
                +"Agradecemos por confiar em nós e valorizamos sua privacidade."
            }
        }
    }
}
